export const Loader = () => (
  <div className='dot-opacity-loader'>
    <span></span>
    <span></span>
    <span></span>
  </div>
)